import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { useHistory } from 'react-router';
import useSWR from 'swr';
import { useTheme } from 'styled-components';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import Text from '../../../common/base/Text';
import EmptyState, { StyledEmptyStateWrapper } from '../../../common/EmptyState';
import { Div } from '../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { StyledViewContent, StyledViewLayout, StyledViewNav, StyledViewNavActions, StyledViewNavHeader } from '../../../layouts/ViewLayout';
import { useOutpostConfig } from '../OutpostContext';
import OperatorEventsList from './OperatorEventsList';
import useSearchQuery from '../../../hooks/useSearchQuery';
import { extractFromArray } from '../../../../utils';
import Button from '../../../common/base/Button';
const limit = 25;
interface OperatorEventsQueryParams {
  next?: string | string[];
  prev?: string | string[];
}
const OperatorEventsView: React.FC = () => {
  const $ = _c(19);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const history = useHistory();
  const {
    query,
    updateSearchQuery
  } = useSearchQuery();
  const theme = useTheme();
  const {
    config
  } = useOutpostConfig();
  const is_enabled = !!config.OPERATOR_EVENTS_HTTP_URL;
  let filters;
  let t0;
  let t1;
  if ($[0] !== is_enabled || $[1] !== query.next || $[2] !== query.prev) {
    filters = {
      limit,
      next: extractFromArray(query.next || []) as string,
      prev: extractFromArray(query.prev || []) as string
    };
    t0 = useSWR;
    t1 = is_enabled ? APIMethodKeys.outpost.operatorEvents.events.list(filters) : null;
    $[0] = is_enabled;
    $[1] = query.next;
    $[2] = query.prev;
    $[3] = filters;
    $[4] = t0;
    $[5] = t1;
  } else {
    filters = $[3];
    t0 = $[4];
    t1 = $[5];
  }
  let t2;
  if ($[6] !== HookdeckAPI.outpost.operatorEvents.events || $[7] !== filters) {
    t2 = () => HookdeckAPI.outpost.operatorEvents.events.list(filters);
    $[6] = HookdeckAPI.outpost.operatorEvents.events;
    $[7] = filters;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const {
    data: events_response,
    isLoading: is_events_loading
  } = t0(t1, t2);
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      y: 5
    };
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Div flex={{
      align: "center",
      justify: "space-between",
      gap: 2
    }}><Text semi={true} ellipsis={true}>Operator Events</Text></Div>;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <StyledViewNav><StyledViewNavHeader p={t3}>{t4}<StyledViewNavActions><Button outline={true} to="/settings/project/monitoring" icon="settings">Configure</Button></StyledViewNavActions></StyledViewNavHeader></StyledViewNav>;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== events_response || $[13] !== history || $[14] !== is_enabled || $[15] !== is_events_loading || $[16] !== theme || $[17] !== updateSearchQuery) {
    t6 = <StyledViewLayout><StyledViewContent>{t5}{is_enabled ? <OperatorEventsList events_response={events_response} loading={is_events_loading} onRowSelected={event_id => {
          if (event_id) {
            const event = events_response?.models.find(e => e.id === event_id);
            history.push(`/operator-events/${event_id}`, {
              event
            });
          }
        }} onNextPage={events_response?.pagination?.next ? () => {
          updateSearchQuery({
            next: events_response.pagination.next,
            prev: undefined
          });
        } : undefined} onPreviousPage={events_response?.pagination?.prev ? () => {
          updateSearchQuery({
            prev: events_response.pagination.prev,
            next: undefined
          });
        } : undefined} /> : <StyledEmptyStateWrapper><EmptyState title="Operator Events" description="Operator events notify your systems about tenant activity, including alerts. Add an operator event destination in settings to enable them." asset={`alerts-${theme.mode}.png`} asset_position="background" cta={{
            icon: "settings",
            label: "Configure",
            to: "/settings/project/monitoring"
          }} /></StyledEmptyStateWrapper>}</StyledViewContent></StyledViewLayout>;
    $[12] = events_response;
    $[13] = history;
    $[14] = is_enabled;
    $[15] = is_events_loading;
    $[16] = theme;
    $[17] = updateSearchQuery;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
export default OperatorEventsView;